import React, { useEffect, useState } from "react";
import axios from "axios";
import api from "../axiosConfig";
import { formattedCurrentMonthSummaryData } from "../helpers/currentMonthSummaryData";
import { getUser } from "../helpers";
import { useModalContext } from "../ModalContext";

const CurrentMonthSummaryRowData = (monthYear, type, currency) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const user = getUser();
  useEffect(() => {
    const fetchData = (filters, user) => {
      setLoading(true);
      api
        // .post("/api/datatablecurrentsummary", {
        .post("/api/datatablecurrentsummaryrevqty", {
          body: filters,
          user: user,
          currencyType: currency,
          page: "summary",
        })
        .then((response) => {
          // const formattedData = formattedSummaryData(response.data);
          setData(formattedCurrentMonthSummaryData(response.data) || []);
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching filtered data:", error);
          setError(error);
          setLoading(false);
        });
    };

    fetchData({
      warehouse: "",
      channel: "",
      category: "",
      product: "",
      month: monthYear ? monthYear?.$M : "",
      year: monthYear ? monthYear?.$y : "",
      type: type,
      user,
    });
  }, [monthYear, type, currency]);

  return { loading, data };
};

export default CurrentMonthSummaryRowData;
